export default __webpack_public_path__ + "static/media/4b.97427bf9.png";